import React from "react";

export default () => (
  <section id="benefits">
    <div className="section_hexagon" />
    <div className="section_title">
      <p>BENEFITS</p>
      <h2>福利厚生</h2>
    </div>
    <div className="section_contents">
      <div className="benefits_item">
        <div className="image">
          <svg
            className="svgIcon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 49.2 68.74"
          >
            <title />
            <path d="M48.76,30.47,26.32.85a2.17,2.17,0,0,0-3.44,0L.44,30.47a2.16,2.16,0,0,0,1.72,3.46h9.57a2.16,2.16,0,0,1,2.16,2.16v30.5A2.15,2.15,0,0,0,16,68.74H33.15a2.15,2.15,0,0,0,2.16-2.15V36.09a2.16,2.16,0,0,1,2.16-2.16H47A2.16,2.16,0,0,0,48.76,30.47Z" />
          </svg>
        </div>
        <div className="group">
          <p className="title">賞与・昇給</p>
          <ul className="list">
            <li>賞与あり（業績に応じて支払い　2023年度は1.5ヶ月分の実績）</li>
            <li>昇給年1回（7月）</li>
          </ul>
        </div>
      </div>
      <div className="benefits_item">
        <div className="image">
          <svg
            className="svgIcon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 95.36 94.8"
          >
            <title />
            <path d="M29.27,26.64A4,4,0,0,0,28.14,30c.21,1.89.78,9.41,4.78,8.07h0c.16,1.12,1.14,6.23,3.63,7.59v10.5h-.21l-.12,0v0h0a29.9,29.9,0,0,0,11.49,9.59,29.62,29.62,0,0,0,10.76-8.61c.29-.36.54-.69.73-1h0l0,0h-.36V45.69c2.77-1.58,3.44-6.16,3.62-7.47a.5.5,0,0,0,0-.12c4,1.33,4.57-6.18,4.77-8.07a4,4,0,0,0-1.12-3.39,6.9,6.9,0,0,0,.43-1.16,23.58,23.58,0,0,0,.84-4.82C67.57,18,67.32,15,66,13.19A18.15,18.15,0,0,0,64.11,11c-1.86-1.85-4.3-3.71-5.72-3.71C56.09,3.1,53.13.4,47.69,0c-.33,0-.68,0-1,0-4.52-.06-12.31,5.35-15.4,11s-4,7.57-2.43,14.53A6.9,6.9,0,0,0,29.27,26.64Z" />
            <path d="M93.69,78.11c-.55-2.81-15.5-11.74-25.51-17.3-2.9-1.63-5.43-3-7.12-3.86l0,0L61,57c1.07,1.66,2.38,4.11,2,5.55-.52,2.08-3.91,8.52-7.67,14-.47.67-.94,1.34-1.42,2-.06-.12-2.86-5.2-5.28-9.4l-1-1.71v0c-2.3,3.92-5.47,9.67-6.14,10.89l-.14.23c-4.3-5.82-8.5-13.66-9.09-16-.29-1.19.55-3.06,1.45-4.61.2-.34.4-.65.59-.92l-.05,0,0-.05C27.45,60.46,2.4,74.45,1.67,78.11,1,81.3.25,89,0,91.52a1.2,1.2,0,0,0,.9,1.3c4.49,1.13,23.9,2,47.16,2s42-.85,46.39-2a1.21,1.21,0,0,0,.89-1.3C95.11,89,94.33,81.3,93.69,78.11Z" />
          </svg>
        </div>
        <div className="group">
          <p className="title">社会保険</p>
          <ul className="list">
            <li>社会保険完備（健康、厚生年金、労災、雇用）</li>
            <li>関東ITソフトウェア健康保険組合の保養施設、提携スポーツクラブ等の利用</li>
          </ul>
        </div>
      </div>
      <div className="benefits_item">
        <div className="image">
          <svg
            className="svgIcon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 64.33 82.63"
          >
            <title />
            <path d="M9.25,61.26h1.69v3.21a2.86,2.86,0,0,0,2.85,2.85h4.27a2.86,2.86,0,0,0,2.85-2.85V61.26h22.5v3.21a2.86,2.86,0,0,0,2.85,2.85h4.28a2.86,2.86,0,0,0,2.85-2.85V61.26h1.69a7.74,7.74,0,0,0,7.72-7.71V7.12A7.15,7.15,0,0,0,55.67,0h-47A7.14,7.14,0,0,0,1.54,7.12V53.55A7.73,7.73,0,0,0,9.25,61.26Zm13.61-13.7a4.21,4.21,0,1,1-4.21-4.2A4.2,4.2,0,0,1,22.86,47.56Zm27,0a4.21,4.21,0,1,1-4.21-4.2A4.2,4.2,0,0,1,49.88,47.56ZM24.59,7.63V6.77a1.23,1.23,0,0,1,1.24-1.24H38.5a1.24,1.24,0,0,1,1.24,1.24v.86A1.25,1.25,0,0,1,38.5,8.87H25.83A1.24,1.24,0,0,1,24.59,7.63ZM10.32,34.91V17.65a4,4,0,0,1,3.94-3.94H50.07A3.94,3.94,0,0,1,54,17.65V34.91H10.32Z" />
            <path d="M51.57,70.07a5.71,5.71,0,0,1-1,.1H48.25l-1.63,0,0,0h0L49.48,73l2,2H28.9L12.81,75l2.87-2.81,2.06-2h0l0,0H13.79a5.71,5.71,0,0,1-1-.1L5.37,77.34,0,82.61H0l0,0H5.08l4.1-4h46l4.09,4h5.08Z" />
          </svg>
        </div>
        <div className="group">
          <p className="title">諸手当</p>
          <ul className="list">
            <li>通勤手当（月3万円まで）</li>
            <li>休日出勤手当</li>
            <li>深夜残業手当</li>
            <li>時間外勤務手当</li>
            <li>慶弔見舞金支給</li>
            <li>資格取得報奨金制度</li>
            <li>書籍購入支援制度（上限あり）</li>
            <li>物品購入支援制度（業務で必要な物品の購入可・上限あり）</li>
            <li>プロジェクト打ち上げ費用手当（上限あり）</li>
            <li>オーディオブック利用手当（学びやインプットの機会として利用可）</li>
            <li>副業可</li>
          </ul>
        </div>
      </div>
      <div className="benefits_item">
        <div className="image">
          <svg
            className="svgIcon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 88.59 94.8"
          >
            <title />
            <path d="M84.87,6.2H71.62V3a3,3,0,0,0-3-3h-1a3,3,0,0,0-3,3V6.2H47.77V3a3,3,0,0,0-3-3h-1a3,3,0,0,0-3,3V6.2H23.91V3a3,3,0,0,0-3-3h-1a3,3,0,0,0-3,3V6.2H3.69A3.71,3.71,0,0,0,0,9.92V91.07A3.72,3.72,0,0,0,3.69,94.8H84.87a3.72,3.72,0,0,0,3.72-3.73V9.92A3.71,3.71,0,0,0,84.87,6.2ZM23.93,14a6.84,6.84,0,0,1,1.12,1,7,7,0,0,1,1.24,1.85,6.72,6.72,0,0,1,.5,2.5,6.36,6.36,0,0,1-12.72,0,6.52,6.52,0,0,1,.5-2.5,6.74,6.74,0,0,1,1.24-1.85,6.63,6.63,0,0,1,1.13-1v4.46a3.49,3.49,0,1,0,7,0V14.27Zm23.85,0a6.45,6.45,0,0,1,1.12,1,6.74,6.74,0,0,1,1.24,1.85,6.52,6.52,0,0,1,.5,2.5,6.36,6.36,0,1,1-12.72,0,6.18,6.18,0,0,1,1.75-4.35,5.74,5.74,0,0,1,1.16-1v4.46a3.47,3.47,0,1,0,6.94,0V14Zm23.86,0a6.45,6.45,0,0,1,1.12,1A7,7,0,0,1,74,16.76a6.52,6.52,0,0,1,.5,2.5,6.36,6.36,0,1,1-12.72,0,6.72,6.72,0,0,1,.5-2.5,7,7,0,0,1,1.24-1.85,6.35,6.35,0,0,1,1.16-1v4.46a3.47,3.47,0,1,0,6.94,0V14.27ZM78,84.24H10.56V31.09H78Z" />
            <rect x="21.11" y="40.13" width="7.92" height="7.92" />
            <polygon points="41.84 40.19 41.84 40.16 41.84 40.16 41.84 40.13 33.92 40.13 33.92 48.05 41.84 48.05 41.84 40.19" />
            <polygon points="46.74 48.02 46.74 48.05 54.65 48.05 54.65 40.13 46.74 40.13 46.74 48 46.74 48.02 46.74 48.02" />
            <polygon points="59.55 48.02 59.55 48.05 67.47 48.05 67.47 40.13 59.55 40.13 59.55 48 59.55 48.02 59.55 48.02" />
            <rect x="21.11" y="52.95" width="7.92" height="7.92" />
            <polygon points="41.84 53.01 41.84 52.98 41.84 52.98 41.84 52.95 33.92 52.95 33.92 60.87 41.84 60.87 41.84 53.01" />
            <polygon points="46.74 60.87 54.65 60.87 54.65 52.95 46.74 52.95 46.74 60.82 46.74 60.84 46.74 60.84 46.74 60.87" />
            <polygon points="59.55 60.87 67.47 60.87 67.47 52.95 59.55 52.95 59.55 60.82 59.55 60.84 59.55 60.84 59.55 60.87" />
            <polygon points="29.02 65.77 21.16 65.77 21.14 65.77 21.14 65.77 21.11 65.77 21.11 73.69 29.02 73.69 29.02 65.77" />
            <polygon points="41.84 65.82 41.84 65.8 41.84 65.8 41.84 65.77 33.98 65.77 33.95 65.77 33.95 65.77 33.92 65.77 33.92 73.69 41.84 73.69 41.84 65.82" />
            <polygon points="46.74 73.69 54.65 73.69 54.65 65.77 46.79 65.77 46.77 65.77 46.77 65.77 46.74 65.77 46.74 73.63 46.74 73.66 46.74 73.66 46.74 73.69" />
            <polygon points="59.55 73.69 67.47 73.69 67.47 65.77 59.61 65.77 59.58 65.77 59.58 65.77 59.55 65.77 59.55 73.63 59.55 73.66 59.55 73.66 59.55 73.69" />
          </svg>
        </div>
        <div className="group">
          <p className="title">休日・休暇</p>
          <ul className="list">
            <li>完全週休2日制（土日/祝日/年末年始休暇）</li>
            <li>年間休日120日以上</li>
            <li>年次有給休暇（平均取得日数11.5日 平均取得率86.6%）</li>
            <li>慶弔休暇</li>
            <li>リフレッシュ休暇（3年毎最大5日間）</li>
            <li>産前産後休暇/育児休暇</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
)



// WEBPACK FOOTER //
// ./src/Home/Benefits.js